import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Row} from "mdbreact";
import {Link} from "react-router-dom";
import {API_URL} from "../../config/Config";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios/index";
import Merchant from "../../components/merchants/Merchant";

export default class MerchantList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            merchants:[],
        };


    }
    componentDidMount(){
        axios.get(`${API_URL}merchants/merchantsList/`)
            .then(res => {
                if (res.data.status === 1){
                    const merchants = res.data.data.map(obj => obj);
                    this.setState({ merchants, ready:true });
                }else{
                    toast.error(res.data.message,{
                        autoClose: 3000,
                        position: toast.POSITION.TOP_RIGHT,
                        rtl:true
                    });
                }
            });
    }



    render() {
        return (
            <div >
                <div className="jumbotron text-center rtl">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title">مراکز طرف قرارداد</h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>مراکز طرف قرارداد</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    <Row>
                        {this.state.merchants.map( merchant =>
                            <Merchant key={merchant.id} merchantObj={merchant}/>
                        )}

                    </Row>
                </div>

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/MerchantList.js